import { App } from './view/app';

document.body.innerHTML = '';
document.body.appendChild(App());
